/**
 * Canonical public vehicle listing enums (Milestone 2).
 * @module automapListingConstants
 */

export const LISTING_STATUS = {
  DRAFT: "draft",
  ACTIVE: "active",
  PENDING_REVIEW: "pending_review",
  PAUSED: "paused",
  SOLD: "sold",
  ARCHIVED: "archived",
  REJECTED: "rejected",
  UNKNOWN: "unknown",
};

export const AVAILABILITY_STATUS = {
  AVAILABLE: "available",
  PENDING_CONFIRMATION: "pending_confirmation",
  UNAVAILABLE: "unavailable",
  SOLD: "sold",
  UNKNOWN: "unknown",
};

export const PUBLIC_STATUS = {
  VISIBLE: "visible",
  HIDDEN: "hidden",
  UNAVAILABLE: "unavailable",
  NOT_FOUND: "not_found",
};

export const LISTING_TRANSMISSION = {
  AUTOMATIC: "automatic",
  MANUAL: "manual",
  AUTOMATED_MANUAL: "automated_manual",
  CVT: "cvt",
  UNKNOWN: "unknown",
};

export const LISTING_FUEL_TYPE = {
  GASOLINE: "gasoline",
  DIESEL: "diesel",
  HYBRID: "hybrid",
  ELECTRIC: "electric",
  GAS: "gas",
  UNKNOWN: "unknown",
};

export const LISTING_BODY_TYPE = {
  SEDAN: "sedan",
  HATCHBACK: "hatchback",
  SUV: "suv",
  PICKUP: "pickup",
  VAN: "van",
  COUPE: "coupe",
  WAGON: "wagon",
  MOTORCYCLE_PLACEHOLDER: "motorcycle_placeholder",
  OTHER: "other",
  UNKNOWN: "unknown",
};

export const LISTING_FAIR_PRICE_LABEL = {
  BELOW_MARKET: "below_market",
  FAIR_PRICE: "fair_price",
  SLIGHTLY_HIGH: "slightly_high",
  HIGH_PRICE: "high_price",
  NOT_ENOUGH_DATA: "not_enough_data",
  UNKNOWN: "unknown",
};

export const LISTING_RISK_LEVEL = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  UNKNOWN: "unknown",
};

export const DEALER_VERIFICATION_STATUS = {
  VERIFIED: "verified",
  PENDING: "pending",
  UNVERIFIED: "unverified",
  REJECTED: "rejected",
  SUSPENDED: "suspended",
  UNKNOWN: "unknown",
};

/** Legacy placeholder path — UI should render initials instead of loading this asset. */
export const LISTING_PLACEHOLDER_IMAGE = "/client-views/autoclaro/vehicle-placeholder.jpg";

export function isListingPlaceholderImage(url) {
  const value = String(url || "").trim();
  if (!value) return true;
  if (value === LISTING_PLACEHOLDER_IMAGE) return true;
  return value.includes("vehicle-placeholder");
}

export const LISTING_FALLBACK_COPY = {
  price: "Precio no disponible",
  mileage: "Kilometraje no disponible",
  location: "Ubicación por confirmar",
  dealer: "Concesionario por confirmar",
  fairPrice: "Sin suficientes datos",
  risk: "Sin evaluación disponible",
  confirmation: "Disponibilidad por confirmar",
};
